module.exports = {
  GET_MRD_FORM_FIELDS: 'GET_MRD_FORM_FIELDS',
  GET_MRD_STATUSES_SUCCESS: 'GET_MRD_STATUSES_SUCCESS',
  GET_MRD_STATUSES_FAILURE: 'GET_MRD_STATUSES_FAILURE',
  GET_MRD_TYPES_SUCCESS: 'GET_MRD_TYPES_SUCCESS',
  GET_MRD_TYPES_FAILURE: 'GET_MRD_TYPES_FAILURE',
  GET_POSTAL_OPERATORS_SUCCESS: 'GET_POSTAL_OPERATORS_SUCCESS',
  GET_POSTAL_OPERATORS_FAILURE: 'GET_POSTAL_OPERATORS_FAILURE',
  EDIT_MRD_REQUEST: 'EDIT_MRD_REQUEST',
  EDIT_MRD_SUCCESS: 'EDIT_MRD_SUCCESS',
  EDIT_MRD_FAILURE: 'EDIT_MRD_FAILURE',
  ADD_MRD_REQUEST: 'ADD_MRD_REQUEST',
  ADD_MRD_SUCCESS: 'ADD_MRD_SUCCESS',
  ADD_MRD_FAILURE: 'ADD_MRD_FAILURE',
  ADD_MRD_STATUS: 'ADD_MRD_STATUS',
  ASSOCIATE_HANDLER_STATUS: 'ASSOCIATE_HANDLER_STATUS',
  ASSOCIATE_HANDLER_REQUEST: 'ASSOCIATE_HANDLER_REQUEST',
  ASSOCIATE_HANDLER_SUCCESS: 'ASSOCIATE_HANDLER_SUCCESS',
  ASSOCIATE_HANDLER_FAILURE: 'ASSOCIATE_HANDLER_FAILURE',
  GET_ACTIVE_MRD_LIST_REQUEST: 'GET_ACTIVE_MRD_LIST_REQUEST',
  GET_ACTIVE_MRD_LIST_SUCCESS: 'GET_ACTIVE_MRD_LIST_SUCCESS',
  GET_ACTIVE_MRD_LIST_FAILURE: 'GET_ACTIVE_MRD_LIST_FAILURE',
  FETCH_INBOUND_DATA_LOCATION_LIST_REQUEST: 'FETCH_INBOUND_DATA_LOCATION_LIST_REQUEST',
  FETCH_INBOUND_DATA_LOCATION_LIST_SUCCESS: 'FETCH_INBOUND_DATA_LOCATION_LIST_SUCCESS',
  FETCH_INBOUND_DATA_LOCATION_LIST_FAILURE: 'FETCH_INBOUND_DATA_LOCATION_LIST_FAILURE',
};
